export default __webpack_public_path__ + "assets/images/704d30882fbcc8b114a7eedaa23da26a.svg";